import { initRequestInterceptors } from '@tencent/wphk-components-project-common';
import { RequestConfig, login } from '@tencent/wphk-act-base-api';
import { hideLoading } from '@tencent/wphk-act-base-ui';

// 自动检测登陆态、并实现自动登陆，同时拦截登陆超时后的请求
initRequestInterceptors({
  sessionOut: {
    beforeLogin() {
      // 执行登陆操作前的处理，如关闭loading等，没有的话可不处理
      hideLoading();
    },
    login() {
      // 进行微信Auth登陆
      login.login({ scope: false, domain: RequestConfig.WX_LOGIN_DOMAIN, force: true });
    },
  },
});
